import { AddIcon, MinusIcon, WhiteboardCommentIcon } from '@sketchnote/icons';
import { useRouter } from 'next/router';
import { memo, useCallback, useEffect } from 'react';
import { preventEvent, TDShapeType, TDSnapshot, Tooltip, useTldrawApp } from 'sn-wb-tldraw';
import { useMembers } from 'src/api/services/organisation';
import { useFileStore } from 'src/features/files';
import { notifyUsers } from 'src/features/whiteboard/api/notifyUsers';

const activeToolSelector = (s: TDSnapshot) => s.appState.activeTool;

export const CommentMenu = memo(function CommentMenu() {
  const app = useTldrawApp();

  const { members } = useMembers();
  const hasMention = app.useStore((s) => s.appState.hasMention);
  const mentionedUsers = app.useStore((s) => s.appState.mentionedUsers);
  const message = app.useStore((s) => s.appState.commentMessage);

  const { asPath, query } = useRouter();
  const currentFile = useFileStore(
    useCallback((s) => s.files[query.slug as string], [query.slug as string])
  );

  useEffect(() => {
    const data = members?.data.data.map((member) => {
      return {
        id: member.memberId,
        display: member.firstname + ' ' + member.lastname,
        role: member.role,
        avatar: member.avatar,
        email: member.email,
      };
    });
    app.setMembers(data);
  }, [members]);

  useEffect(() => {
    const sendMail = async () => {
      const origin =
        typeof window !== 'undefined' && window.location.origin ? window.location.origin : '';

      const URL = `${origin}${asPath}`;
      await notifyUsers(
        URL,
        query.slug as string,
        query.view as string,
        mentionedUsers,
        message,
        currentFile?.name as string
      );
      app.setMention(false);
    };
    if (hasMention) {
      sendMail();
    }
  }, [hasMention]);

  const activeTool = app.useStore(activeToolSelector);
  const isActive = activeTool === TDShapeType.Comment;

  return (
    <div
      style={{
        position: 'absolute',
        top: '8%',
        right: '2%',
        display: 'flex',
        pointerEvents: 'all',
        width: '32px',
        height: '32px',
        background: `${isActive ? '#EEF1FC' : 'none'}`,
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      onClick={() => {
        app.selectTool(TDShapeType.Comment);
        app.setDefaultOpen(true);
      }}
    >
      <Tooltip label="Comment" side="left">
        <WhiteboardCommentIcon fill={isActive ? '#254DDA' : '#878A92'} />
      </Tooltip>
    </div>
  );
});
